/* eslint-disable eqeqeq */
import * as React from 'react'
import { _helpers } from '../../../lib/ProjectReportValidation';
import { DataService } from '../../../services/DataService';
import { handleFieldChange } from './editkickbackutilty';
import { GroupedProjectNameAndEndDate, TKickbackReportById, TKickbackReportByIdContract, TKickbackReportType } from '../../../services/API/Kickback';
import { ContractDict } from '../../../pages/KickbackProjectReportPage';
import { EditableFields } from './editkickbacktypes';
import i18n from '../../../i18n';

interface Props{
    supplier:string;
    initialFields: TKickbackReportByIdContract[];
    kickbackReportType:TKickbackReportType;
    kickbackReportId:string;
}
type Status = {
    key:number;
    value:string;
    element:JSX.Element;
  }
export const useEditKickbackHook = ({supplier,initialFields,kickbackReportType,kickbackReportId}:Props) => {
    const [fields, setFields] = React.useState<TKickbackReportByIdContract[]>(initialFields);
    const [kickbackReport, setKickbackReport] = React.useState<Required<TKickbackReportById>>();
    const [contracts,setContracts] = React.useState<ContractDict>({});
    const [projectNamesAndDates,setProjectNamesAndDates] = React.useState<GroupedProjectNameAndEndDate>({});
    const [projectNames,setProjectNames] = React.useState<string[]>([]);
    const [invoiceReferences,setInvoiceReferences] = React.useState<string[]>([]);
    const [invoiceIdentifiers,setInvoiceIdentifiers] = React.useState<string[]>([]);
    const [status,setStatus] = React.useState<Status | undefined>(undefined)
    const handleInit = React.useCallback(async() => {     
            const bla =  kickbackReportType == "Project" ? 
                await DataService.Kickback.GetProjectReportById(kickbackReportId)
                 :
                 await DataService.Kickback.GetByReportId(kickbackReportId,i18n.language);
         if(kickbackReportType == 'Project'){
            DataService.Kickback.GetTypeaheadListsForKickbackProjectReports(supplier).then(result => {
               // const customerDict = _helpers.createCustomerDict(result[4]);
                  
                // const contractDict = _helpers.createContractDict(result[5]);
                // setContracts(contractDict);
                const handleProjectEndDates = _helpers.handleHistoricProjectEndDates(
                    result[3],
                    result[5]
                );
                setProjectNamesAndDates(handleProjectEndDates);
                setProjectNames(result[0]);
                setInvoiceReferences(result[1]);
                setInvoiceIdentifiers(result[2]);
               }).catch(err => {
                console.log(err)
            });
              const contractReplaced = await DataService.Contracts.GetTest(supplier,bla.period.split('-')[0],bla.period.split('-')[1],i18n.language)
               
              const contractDict = _helpers.createContractDict(contractReplaced);
                setContracts(contractDict)
            } 
         else{
            // DataService.Kickback.GetTypeaheadListsForKickbackProjectReports(supplier).then(result => {
            //     const contractDict = _helpers.createContractDict(result[5]);
            //     setContracts(contractDict)
            // }).catch(err => {
            //     console.log(err)
            // })
            const contractReplaced = await DataService.Contracts.GetTest(supplier,bla.period.split('-')[0],bla.period.split('-')[1],i18n.language)
                const contractDict = _helpers.createContractDict(contractReplaced);
                setContracts(contractDict)
         } 
         setFields(bla.contracts);   
         setKickbackReport(bla); 

    },[kickbackReportType,kickbackReportId,supplier])
    React.useEffect(() => {            
           handleInit();       
    },[supplier,handleInit])
    const onFieldChange = (prop: EditableFields,
        id: number,
        value: any,incomingContext:any) => {
            const context = (prop: EditableFields) => {
                switch (prop) {
                    case 'contractId':
                        console.log('NU ÄNDRADES ETT CONTRACTSID',contracts)
                      return {type: prop,contracts,projectNamesAndDates,text: incomingContext.text};
                    case 'projectEndDate':
                        return {type:prop,projectNamesAndDates,setter:setProjectNamesAndDates}
                    case 'projectName':
                        return {type:prop,projectNamesAndDates,source:projectNames,setter:setProjectNames,text:incomingContext.text}
                    case 'invoiceIdentifier':
                        return {type:prop,text:incomingContext.text,source:invoiceIdentifiers,setter:setInvoiceIdentifiers}
                    case 'invoiceReference':
                        return {type:prop,text:incomingContext.text,source:invoiceReferences,setter:setInvoiceReferences}
                    case 'comment':
                    case 'commentKickbackChange':
                    case 'invoicedSum':
                    case 'reportedSum':
                    case 'status' :
                    case 'department':    
                      return { type: prop };
                  }
            }
           
            setKickbackReport((prevKickbackReport) =>
            {
                if(typeof prevKickbackReport !== 'undefined'){
                    
                   return handleFieldChange(prop,prevKickbackReport, id, value,context(prop)) 
                }
                else{
                    return undefined;
                }
            }
            )
      };
    
      return {
        fields,
        onFieldChange,
        setFields,
        kickbackReport,
        projectNames,
        invoiceReferences,
        invoiceIdentifiers,
        status,
        setStatus,
        projectNamesAndDates
      };
}